<script setup lang="ts">
import { useVModel } from '@vueuse/core'

const { t } = useI18n()

const props = defineProps<{ modelValue: string }>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const value = useVModel(props, 'modelValue', emit)
</script>

<template>
  <div class="relative flex w-full rounded-3xl bg-muted p-1.5 text-center">
    <div
      class="z-10 w-1/2 cursor-pointer rounded-3xl p-2 text-xs font-medium text-foreground-secondary"
      @click="value = 'claimedRewards'"
    >
      {{ t('pages.loyaltyPage.mockup.devices.webapp.rewards.reward') }}
    </div>
    <div
      class="z-10 w-1/2 cursor-pointer rounded-3xl p-2 text-xs font-medium text-foreground-secondary"
      @click="value = 'allRewards'"
    >
      {{ t('pages.loyaltyPage.mockup.devices.webapp.rewards.store') }}
    </div>
    <div
      class="shadow-xs absolute left-0 top-0 z-0 mt-0.5 h-[40px] w-1/2 rounded-3xl bg-white transition-transform duration-300 ease-in-out"
      :class="value === 'claimedRewards' ? 'ml-0.5' : '-ml-0.5'"
      :style="{ transform: value === 'allRewards' ? 'translateX(100%)' : 'translateX(0)' }"
    ></div>
  </div>
</template>
